import * as FromOther from 'reducers/ai/selectors';

const SLICE = 'ai';

export const getRestoringState = state =>
  FromOther.getRestoringState(state[SLICE]);

export const getFormValues = state => FromOther.getFormValues(state[SLICE]);
